import React, { useMemo } from "react";
import { Button, Modal } from "components/bootstrap";
import { SelectedRowsProvider, useSelectedRows } from "common/contexts";
import { Row } from "common/components";
import EventProcedureStepLibraryList from "./List";
const Buttons = ({ onClose, onAdd }) => {
  const selectedRows = useSelectedRows();
  const selectedSteps = useMemo(
    () => selectedRows.map((step) => {
      delete step.type;
      return step;
    }),
    [selectedRows]
  );
  return /* @__PURE__ */ React.createElement(Row, { $justify: "flex-end", $align: "center" }, /* @__PURE__ */ React.createElement(Button, { onClick: onClose }, "Cancel"), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", disabled: selectedRows.length < 1, onClick: () => onAdd(selectedSteps) }, "Add Steps"));
};
function EventProcedureStepLibraryForm({ selectedSteps, onClose, onAdd }) {
  return /* @__PURE__ */ React.createElement(SelectedRowsProvider, null, /* @__PURE__ */ React.createElement(Modal, { show: true, onHide: onClose, bsSize: "lg" }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, "Add Step from Library")), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(EventProcedureStepLibraryList, { selectedSteps })), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(Buttons, { onClose, onAdd }))));
}
export default EventProcedureStepLibraryForm;
